import UpSellCarouselSkeleton from "./UpSellCarouselSkeleton";

const ErrorComponent = () => <UpSellCarouselSkeleton isError={true} />;

export default ErrorComponent;
